<template>
    <div>
        <!-- <button type="button" v-on:click="onexport">Excel download</button> -->

    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Anasayfa</h2>
      </div>
    </div>
    
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row mt-2 mb-2">
          <!-- <div class="col-lg-9 col-12">
            <button class="btn btn-outline-primary mr-2" @click="filter('All')">{{donem}}</button>
            <button class="btn btn-outline-secondary mr-2" v-for="(key,value) in this.$helper.groupByAdet(posts,'ay')"
            :key="value" @click="filter(value)">{{value}}</button>
          </div> -->
          <div class="col-lg-12 col-12">
              <input class="form-control"  style="height:60px;"  v-model="arama"  placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
          </div>
        </div>
     <div class="row">
        <div class="col-12" v-if="arama.length >3">
         <div class="block margin-bottom-sm">
            <div class="table-responsive"> 
               <table id="tablo" class="table table-striped">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Cihaz</th>
                      <th>Sağlayıcı</th>
                      <th>Bölge</th>
                      <th>Müşteri</th>
                      <!--<th>Ekip</th>-->
                      <th>Çağrı Tarih</th>
                       <th>Son işlem</th>
                      
                      <th>Tipi</th>
                      <!-- <th>Durum</th> -->
                    </tr>
                  </thead>
                  <tbody>
                   <tr v-for="(post,index) in posts" :key="index">
                      <td><router-link :to="`/detay/servis/${post.fid * 8848+'bn'+post.said*8847+'sd'+post.bid*8846+'bn'+post.sid*8589+'bn'+3*8589}`">{{post.no}}</router-link></td>
                     <td><router-link :to="`/detay/cihaz/${post.cid}`">{{post.barkod}}</router-link></td>
                    <td>{{post.sa}}</td>
                    <td class="dashtext-2">{{post.bolge}}</td>
                    <td><router-link :to="`/detay/cari/${post.carid}`">{{post.cari}}</router-link></td>
                    <!--<td>{{post.ekipName}}</td>-->
                    <td class="text-info">{{$helper.trtgoster(post.ct1)}}</td>
                    <td class="text-info">{{$helper.trtgoster(post.ptarih)}}</td>
                    <td class="dashtext-3">{{post.st}}</td>
                    <!-- <td class="dashtext-3" v-if="post.onay===0">Onaysız</td>
                    <td class="text-info" v-else>Onaylı</td> -->


                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>                
        <div class="row">

            <div class="col-lg-8 col-12 statistic-block block">
              <div class="row">
                <div class="col-6" style="border:1px solid #484848" v-for="(item,index) in newObject" :key="index">

                <div class="stats-3-block block d-flex">
                  <div class="stats-3"><strong class="d-block dashtext-5">%{{(item.uymayan / item.servis) * 100}}</strong><span class="d-block">{{item.ay}}</span>
                    <div class="progress progress-template progress-small">
                      <div role="progressbar" style="width: 35%;" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template progress-bar-small dashbg-1"></div>
                    </div>
                  </div>
                  <div class="stats-3 d-flex justify-content-between text-center">
                    <div class="item"><strong class="d-block strong-sm">{{item.servis}}</strong><span class="d-block span-sm">SerVİS</span>

                    </div>
                    <div class="item"><strong class="d-block strong-sm">{{item.uymayan}}</strong><span class="d-block span-sm">servis 3+</span>
                    </div>
                  </div>
                </div>

                </div>
              </div>

                    <!-- <div v-for="(item,index) in newObject" :key="index"  class="statistic-block col-3">
                      <div class="progress-details d-flex align-items-end justify-content-between">
                        <div class="title">
                          <div class="icon"><i class="icon-contract"></i></div><strong>{{item.ay}} ayında 3 günden fazla süren servislerin yüzdesi</strong>
                        </div>
                        <div class="number dashtext-3">{{posts.length}}</div>
                      </div>
                      <div class="progress progress-template">
                        <div role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-3"></div>
                      </div>
                    </div>               -->

            </div>
            <div class="col-lg-4 col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="statistic-block block">
                      <div class="progress-details d-flex align-items-end justify-content-between">
                        <div class="title">
                          <div class="icon"><i class="icon-contract"></i></div><strong>Toplam Servİs</strong>
                        </div>
                        <div class="number dashtext-3">{{posts.length}}</div>
                      </div>
                      <div class="progress progress-template">
                        <div role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-3"></div>
                      </div>
                    </div>
                  </div>
                  <div v-for="(bir,iki) in this.$helper.groupByAdet(posts,'sd')" :key="bir"  class="col-12">
                    <div class="statistic-block block">
                      <div class="progress-details d-flex align-items-end justify-content-between">
                        <div class="title">
                          <div class="icon"><i class="icon-contract"></i></div><strong>{{iki}}</strong>
                        </div> 
                        <div class="number dashtext-2">{{bir}}</div>
                      </div>
                      <div class="progress progress-template">
                        <div role="progressbar" v-bind:style="{width :  (bir / posts.length)*100 + '%' }" class="progress-bar progress-bar-template dashbg-2"></div>
                      </div>
                    </div>
                  </div>

                </div>
            </div>
            
        </div>
      </div>

    </section>
    <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
  </div>
</template>
<script>
export default {
   async created() {
     this.progres.inprogres = true
     await this.yetki();
   //  this.location()
  },
  data () {
    return {
      arama:'', // genel arama
    // id : this.$route.params.id/8589,
      posts : [],
      error :[],
      donem : this.$request.donem(),
      durum:{},
      durums:{},
      sn:{},
      ays:{},
      ayar:this.$request.ayar(),
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:true
      },
      newObject:[]
      
    }
  },
    methods : {
      yetki:function(){
          let baslat = false;
          let table ='';
            if (this.ayar.ya==='sid'){
                table = 'servis'
                baslat = true
                this.getPostsAsync(table,baslat)
            }
            else{
              table = 'kayit'
              baslat=true
              this.getPostsAsync(table,baslat)
            }

      },

      getPostsAsync (table,baslat){
        if (baslat){
          this.$request.get("servis/servis/"+this.ayar.ya+"/"+this.ayar.kid+"/"+this.donem+'/'+this.ayar.p)
          .then(res => {
            console.log(res)
              this.posts = res.results.sort((t1,t2) => t1.sid < t2.sid ? -1 : 1)
              this.progres.inprogres = false
            this.performans(res.results,3);
            })
          .catch(err => {this.error.push(err)})
        }
      },

    performans (arr,rakam){
      var result=[]
      //console.log(result)
      arr.forEach(function (a) {
      if(a.sdid === 4){
      var MS_one_day = 1000 * 60 * 60 * 24;
      var y = new Date(a.tarih);
      var x = new Date(a.ptarih);
      var date1= Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()); //x
      var date2 = Date.UTC(y.getFullYear(), y.getMonth(), y.getDate()); //y
      let guns = Math.floor((date2 - date1) / MS_one_day);
        if ( !this[a.ay] ) {
            this[a.ay] = { ay:a.ay,servis:0,uymayan:0};
            result.push(this[a.ay]);
        } 
        this[a.ay].servis += +1;
        if (guns<=rakam) {
          this[a.ay].uymayan += +1;
        }
      }
    //   this[a.color].instances += a.instances;
    }, Object.create(null));
    //console.log(result)
    this.newObject = result
    } , 

      performanss(arr){
        arr.forEach(e => {
          if(e.sdid === 4){
            let data = {
              bolge:e.bolge,
              ay:e.ay,
              gun:this.$helper.gunhesapla(e.tarih,e.ptarih)
            }
            this.newObject.push(data)
          }
          });
      }


  }
}
</script>




// WEBPACK FOOTER //
// src/views/home.vue